import React from 'react';
import { LogOut, Monitor, AlertTriangle, X } from 'lucide-react';

const LogoutModal = ({ isOpen, type, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;

  const modalConfig = {
    logout: {
      title: 'Log Out',
      description: 'Are you sure you want to log out of this device?',
      confirmText: 'Log Out',
      icon: LogOut,
      deviceCount: 1
    },
    logoutAll: {
      title: 'Log Out of All Devices',
      description: 'This will log you out of all devices where you are currently signed in, including this one.',
      confirmText: 'Log Out',
      icon: Monitor,
      deviceCount: 3 // Example count
    }
  };

  const config = modalConfig[type];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-md w-full mx-auto">
        {/* Content */}
        <div className="p-6">
          {/* Description */}
          <p className="text-gray-700 text-center mb-6">
            {config.description}
          </p>

          {/* Action Buttons */}
          <div className="flex space-x-3">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 px-4 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  <span>Logging out...</span>
                </>
              ) : (
                <>
                  <span>{config.confirmText}</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Security Notice */}
        <div className="bg-gray-50 rounded-b-2xl p-4 border-t border-gray-200">
          <p className="text-xs text-gray-600 text-center">
            You will need to log in again to access your account.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;